import { HIDDEN } from '../classnames/design-system';
import { PaginationButton } from './button';
import { SELECTORS } from './constants';

export class PaginationUI {
  constructor() {
    this.wrapper = document.querySelector(`.${SELECTORS.PAGINATION}`);
  }

  hidePagination = () => {
    this.wrapper.classList.add(HIDDEN);
  };

  updateButton = (id, isDisabled, onClick) => {
    const buttonElement = this.wrapper.querySelector(`.${id}`);
    const paginationButton = new PaginationButton({
      elem: buttonElement,
      isDisabled,
      onClick
    });

    buttonElement.replaceWith(paginationButton.update());
  };

  renderPageButtons = (pageRange, currentPage, onChangePage) => {
    const buttonsWrapper = this.wrapper.querySelector(`.${SELECTORS.PAGE_BTNS}`);
    buttonsWrapper.innerHTML = '';

    pageRange.forEach((page) => {
      const paginationButton = new PaginationButton({
        page,
        isActive: page === currentPage,
        onClick: () => onChangePage(page)
      });

      buttonsWrapper.appendChild(paginationButton.update());
    });
  };

  render = () => {
    this.wrapper.classList.remove(HIDDEN);
  };
}
